import { Backend, getQueryParamValue } from '@shared/datastore/core';
import { MilestoneRequestsGetResultApi } from 'api-typings/projects/projects';

declare module '../core/backend' {
  interface BackendApiFetchTypes {
    milestoneRequests: MilestoneRequestsGetResultApi;
  }
}

export const milestoneRequestsBackend: Backend<'milestoneRequests'> = {
  fetch: (_, ids, query) => ({
    endpoint: `projects/0.1/milestone_requests`,
    params: {
      bids: query ? getQueryParamValue(query, 'bidId') : [],
      projects: query ? getQueryParamValue(query, 'projectId') : [],
    },
  }),
};



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/milestone-requests/milestone-requests.backend.ts